import { useMutation } from '@tanstack/react-query'
import { postArticleCountViews } from "./api"

export const useMutationArticleCountViews = () => {
  return useMutation({
    mutationFn: (id) => postArticleCountViews(id)
  })
}
